import { Reveal } from "@components/ui";

const pillars = [
  { label: "Waste Reduction", detail: "Efficient systems that minimize resource waste" },
  { label: "Energy Efficiency", detail: "Promoting appliances that use less energy" },
  { label: "Smart Monitoring", detail: "Real-time consumption tracking via smart meters" },
];

export function EnvironmentalSection() {
  return (
    <section className="w-full bg-white pt-12 md:pt-16 lg:pt-[120px] pb-[40px] md:pb-[50px] lg:pb-[60px] px-5 md:px-10 lg:px-[180px]">
      <div className="w-full max-w-[1368px] mx-auto">
        <div className="relative rounded-[24px] overflow-hidden bg-gradient-to-br from-[#0d9488] to-[#065f46] p-8 md:p-12 lg:py-16 lg:px-20">
          {/* Decorative circles */}
          <div className="absolute -top-20 -right-20 w-[200px] h-[200px] rounded-full bg-white/[0.04]" />
          <div className="absolute -bottom-16 -left-16 w-[160px] h-[160px] rounded-full bg-white/[0.04]" />

          <Reveal direction="up">
            <div className="relative z-10 flex flex-col items-center text-center gap-5">
              <span className="inline-block px-4 py-1.5 rounded-full bg-white/10 text-white/90 text-[13px] font-semibold tracking-[0.04em] uppercase font-albert-sans">
                Sustainability
              </span>
              <h2 className="text-[28px] md:text-[36px] lg:text-[48px] tracking-[-0.04em] font-semibold text-white font-albert-sans leading-[1.1]">
                Environmentally Responsible
              </h2>
              <p className="max-w-[800px] text-[16px] md:text-[20px] lg:text-[24px] tracking-[-0.04em] text-white/80 font-albert-sans leading-[1.5]">
                We reduce waste, promote energy efficient appliances, and encourage
                customers to monitor consumption using smart meters — contributing to a
                more sustainable UAE.
              </p>
            </div>
          </Reveal>

          <Reveal direction="up" delay={100}>
            <div className="relative z-10 grid grid-cols-1 sm:grid-cols-3 gap-4 mt-10">
              {pillars.map((pillar) => (
                <div
                  key={pillar.label}
                  className="rounded-[16px] bg-white/10 backdrop-blur-sm border border-white/10 p-5 md:p-6 text-center flex flex-col items-center gap-2"
                >
                  <span className="text-[17px] md:text-[19px] font-semibold text-white tracking-[-0.02em] font-albert-sans">
                    {pillar.label}
                  </span>
                  <span className="text-[14px] md:text-[15px] text-white/65 tracking-[-0.02em] font-albert-sans leading-[1.4]">
                    {pillar.detail}
                  </span>
                </div>
              ))}
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
